import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { PreferredDishesSwimlane } from './components';
import connect from './connect';

function PreferredDishes({
  shop,
  section,
  onBeforeProductConfig,
  trackSwimlane,
  trackSwimlaneSwiped,
  position,
}) {
  if (!section?.products?.length) return null;

  return (
    <PreferredDishesSwimlane
      image={section?.image}
      title={section?.name}
      shopUrl={shop?.url}
      products={section.products}
      swimlaneId={section?.itemId}
      onBeforeProductConfig={onBeforeProductConfig}
      swimlaneShown={trackSwimlane}
      swimlaneSwiped={trackSwimlaneSwiped}
      position={position}
    />
  );
}

PreferredDishes.propTypes = {
  onBeforeProductConfig: PropTypes.func.isRequired,
  shop: PropTypes.object.isRequired,
  trackSwimlane: PropTypes.func.isRequired,
  trackSwimlaneSwiped: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  section: PropTypes.shape.isRequired,
};

export default connect(memo(PreferredDishes));
